module.exports = __webpack_public_path__ + "static/appreciation-f53c70e31ea5ca06fcd63501ffd5e21a.svg";